import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { useMediaQuery } from "react-responsive";

import Header from "../Header/Header";
import Main from "../../pages/MainPage/MainPage";

import PrdListPage from "../../pages/ProductPage/ProdListPage";
import PrdDetailPage from "../../pages/ProductPage/ProdDetailPage";
import PrdDownPage from "../../pages/ProductPage/ProdDownPage";

import '../../assets/css/common.css';
import Footer from "../Footer/Footer";
import OverviewPage from "../../pages/CompanyPage/OverviewPage";
import CeoPage from "../../pages/CompanyPage/CeoPage";
import HistoryPage from "../../pages/CompanyPage/HistoryPage";
import CertListPage from "../../pages/CompanyPage/CertListPage";
import CiPage from "../../pages/CompanyPage/CiPage";
import WayPage from "../../pages/CompanyPage/WayPage";

import InfoPage from "../../pages/RfidNfcPage/InfoPage";
import ChipPage from "../../pages/RfidNfcPage/ChipPage";

import AttendPage from "../../pages/SolutionPage/AttendPage";
import SchoolPage from "../../pages/SolutionPage/SchoolPage";
import NfcPage from "../../pages/SolutionPage/NfcPage";
import RfidPage from "../../pages/SolutionPage/RfidPage";
import TagPage from "../../pages/SolutionPage/TagPage";
import CardprintPage from "../../pages/SolutionPage/CardprintPage";

import NoticePage from "../../pages/Support/NoticePage";
import InquiryPage from "../../pages/Support/InquiryPage";
import BuyPage from "../../pages/Support/BuyPage";
import BuyAcntPage from "../../pages/Support/BuyAcntPage";
import BuyClosePage from "../../pages/Support/BuyClosePage";
import BuySucsPage from "../../pages/Support/BuySucsPage";
import BuyFailPage from "../../pages/Support/BuyFailPage";
import RemotePage from "../../pages/Support/RemotePage";
import NoticeDetailPage from "../../pages/Support/NoticeDetailPage";
import InquiryRegPage from "../../pages/Support/InquiryRegPage";
import InquiryDetailPage from "../../pages/Support/InquiryDetailPage";
import ReferencePage from "../../pages/Support/ReferencePage";

import PartnerPage from "../../pages/PortfolioPage/PartnerPage";
import DeliveryPage from "../../pages/PortfolioPage/DeliveryPage";
import PartnerDetailPage from "../../pages/PortfolioPage/PartnerDetailPage";

import MobileMainPage from "../../pages/MainPage/MobileMainPage";
import MobileHeader from "../Header/MobileHeader";
import TopBackBtn from "../Button/TopBackBtn";

const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 })
  return isMobile ? children : null
}
const Default = ({ children }) => {
  const isNotMobile = useMediaQuery({ minWidth: 768 })
  return isNotMobile ? children : null
}

const Layout = () => {
  
  const location = useLocation();
  const hideFooterPaths = ['/'];

  const shouldHideFooter = hideFooterPaths.includes(location.pathname);

  return(
    <>
      <Default>
        <div>
          <Header />
          <Routes>
            <Route path="/" element={<Main />} />
            
            <Route path="/product/list" element={<PrdListPage />} />
            <Route path="/product/detail" element={<PrdDetailPage />} />
            <Route path="/product/download" element={<PrdDownPage />} />

            <Route path="/company/info" element={<OverviewPage />} />
            <Route path="/company/ceo" element={<CeoPage />} />
            <Route path="/company/history" element={<HistoryPage />} />
            <Route path="/company/certList" element={<CertListPage />} />
            <Route path="/company/ci" element={<CiPage />} />
            <Route path="/company/way" element={<WayPage />} />
            <Route path="/company/overview" element={<OverviewPage />} />
            
            <Route path="/rfid-nfc/info" element={<InfoPage />} />
            <Route path="/rfid-nfc/chip" element={<ChipPage />} />

            <Route path="/solution/attend" element={<AttendPage />} />
            <Route path="/solution/school" element={<SchoolPage />} />
            <Route path="/solution/nfc" element={<NfcPage />} />
            <Route path="/solution/rfid" element={<RfidPage />} />
            <Route path="/solution/tag" element={<TagPage />} />
            <Route path="/solution/cardprint" element={<CardprintPage />} />
            
            <Route path="/support/notice/:pageIdx" element={<NoticePage />} />
            <Route path="/support/notice/detail/:idx" element={<NoticeDetailPage />} />
            <Route path="/support/inquiry/:pageIdx" element={<InquiryPage />} />
            <Route path="/support/inquiry/register" element={<InquiryRegPage />} />
            <Route path="/support/inquiry/detail/:idx" element={<InquiryDetailPage />} />
            <Route path="/support/buy" element={<BuyPage />} />
            <Route path="/support/buy/account" element={<BuyAcntPage />} />
            <Route path="/support/buy/close" element={<BuyClosePage />} />
            <Route path="/support/buy/success" element={<BuySucsPage />} />
            <Route path="/support/buy/fail" element={<BuyFailPage />} />
            <Route path="/support/remote" element={<RemotePage />} />
            <Route path="/support/reference" element={<ReferencePage />} />

            <Route path="/portfolio/partner/:pageIdx" element={<PartnerPage />} />
            <Route path="/portfolio/partner/detail/:idx" element={<PartnerDetailPage />} />
            <Route path="/portfolio/delivery/:pageIdx" element={<DeliveryPage />} />

          </Routes>
          {!shouldHideFooter && <TopBackBtn />}
        </div>
        {!shouldHideFooter && <Footer />}
      </Default>

      <Mobile>
        <div>
          <MobileHeader />
          <Routes>
            <Route path="/" element={<MobileMainPage />} />
            <Route path="/product/list" element={<PrdListPage />} />
            <Route path="/product/detail" element={<PrdDetailPage />} />
            <Route path="/product/download" element={<PrdDownPage />} />

            <Route path="/support/notice/:pageIdx" element={<NoticePage />} />
            <Route path="/support/notice/detail/:idx" element={<NoticeDetailPage />} />
            <Route path="/support/inquiry/:pageIdx" element={<InquiryPage />} />
            <Route path="/support/inquiry/register" element={<InquiryRegPage />} />
            <Route path="/support/inquiry/detail/:idx" element={<InquiryDetailPage />} />
            <Route path="/support/buy" element={<BuyPage />} />
            <Route path="/support/buy/account" element={<BuyAcntPage />} />
            <Route path="/support/buy/close" element={<BuyClosePage />} />
            <Route path="/support/buy/success" element={<BuySucsPage />} />
            <Route path="/support/buy/fail" element={<BuyFailPage />} />
            <Route path="/support/remote" element={<RemotePage />} />
            <Route path="/support/reference" element={<ReferencePage />} />

            <Route path="/company/info" element={<OverviewPage />} />
            <Route path="/company/ceo" element={<CeoPage />} />
            <Route path="/company/history" element={<HistoryPage />} />
            <Route path="/company/certList" element={<CertListPage />} />
            <Route path="/company/ci" element={<CiPage />} />
            <Route path="/company/way" element={<WayPage />} />

            <Route path="/rfid-nfc/info" element={<InfoPage />} />
            <Route path="/rfid-nfc/chip" element={<ChipPage />} />

            <Route path="/solution/attend" element={<AttendPage />} />
            <Route path="/solution/school" element={<SchoolPage />} />
            <Route path="/solution/nfc" element={<NfcPage />} />
            <Route path="/solution/rfid" element={<RfidPage />} />
            <Route path="/solution/tag" element={<TagPage />} />
            <Route path="/solution/cardprint" element={<CardprintPage />} />
            
            <Route path="/portfolio/partner/:pageIdx" element={<PartnerPage />} />
            <Route path="/portfolio/partner/detail/:idx" element={<PartnerDetailPage />} />
            <Route path="/portfolio/delivery/:pageIdx" element={<DeliveryPage />} />
            
          </Routes>
        </div>
        {!shouldHideFooter && <Footer />}
      </Mobile>
    </>
  );
};

export default Layout;